import { Fade, Zoom } from "react-awesome-reveal";
import IconLogo from "../assets/img/icon-logo.png";
import D3Logo from "../assets/img/logo3d.png";
import CurveArrow from "../assets/img/gcgtc.png";

const Overview = () => {

    return (
        <div id="Overview" className='min-h-full lg:h-full md:min-h-0 bg-[#FFF] px-[15px] xs:px-[30px] lg:px-[57px] pt-[90px] relative z-10'>
            <div className="sm:h-[calc(100%-123px)] relative flex flex-col lg:flex-row gap-5 md:gap-[50px] lg:gap-5 justify-center items-center mt-5 pb-[20px] lg:pb-0">
                <div className='basis-full lg:basis-6/12 h-full lg:flex items-center justify-center relative'>
                    <Zoom triggerOnce={true} duration={1500} className="h-full relative text-center">
                        <div className="w-[50%] lg:w-full h-full mx-[auto] relative">
                            <img src={CurveArrow} alt="logo" className="absolute left-[-30px] top-[10px] rotate-45 w-[30%]" />
                            <img src={D3Logo} alt="logo" className="w-full h-full object-contain relative" />
                        </div>
                    </Zoom>
                </div>
                <div className='relative basis-full lg:basis-6/12 flex flex-col gap-5 items-start justify-center text-white not-italic font-[400] text-[18px] md:text-[22px] lg:text-[18px] leading-[24px] md:leading-[34px] lg:leading-[28px] text-justify'>
                    <Fade triggerOnce={true} direction="up" duration={1500}>
                        <div className="text-[#353736] not-italic font-[700] text-[43px] leading-[150%] text-left relative">
                            Overview
                        </div>
                        <p>XertzSwap is a decentralized exchange (DEX) and an automated market maker (AMM) built on the Cardano blockchain to facilitate trades for users to exchange native Cardano tokens with ADA and also allows participants of the blockchain to add liquidity to native Cardano tokens in a completely decentralized ecosystem.</p>

                        <p>By building on Cardano Blockchain, XertzSwap will be the first project on the Cardano Ecosystem utilizing its smart contracts to build a complete suite of DeFi services on the Cardano Blockchain including a Decentralized Exchange, NFT Marketplace, Launchpad and a Lending Protocol for native Cardano tokens.</p> 
                    </Fade>
                    <img src={IconLogo} alt="icon-logo" className="App-logo absolute top-[-20px] md:top-0 right-0 md:right-[100px] z-10 w-[50px]" />
                </div>
            </div>
        </div>
    )
}

export default Overview;